/**
 * How an SMS reached the customer. Mirrors the Prisma enum of the same name.
 *
 * FULL_TEXT: the message text is in the SMS itself, with the chat link appended.
 * LINK: a short teaser saying a message is waiting, pointing at the chat. The
 * cheap fallback for a message that would otherwise cost several segments.
 */
export enum SmsDeliveryMode {
  FULL_TEXT = "FULL_TEXT",
  LINK = "LINK",
}
